export const ROUTER = Object.freeze ({
    PAGE_UPGRADE: 'upgrade', //dialog xac nhan block account
    PAGE_EXTEND: 'extend', // dialog xac nhan xoa account 
    PAGE_PURCHASE: 'purchase', // dialog xac nhan reject account
})